import { EditActionDefinition } from '@wix/editor-platform-host-integration-apis';

export function filterByTags<
  T extends EditActionDefinition = EditActionDefinition,
>(actions: T[], tags?: string[]) {
  if (!tags) {
    return actions;
  }

  if (tags.length === 0) {
    return actions.filter((action) => !action.tags || action.tags.length === 0);
  }

  const tagsSet = new Set(tags);
  return actions.filter((action) =>
    action.actionName !== 'layout' && !action.tags // TODO: remove 'layout' check when manifest is valid
      ? true
      : action.tags?.some((tag) => tagsSet.has(tag)),
  );
}
